import React from 'react'
import {Card, CardProps, styled} from '@mui/material'
import cardStyles from './card.styles'

interface ApCardProps extends CardProps {
  ap_type: 'login' | 'logout' | 'visit_details'
}

const apAtomName = {ap_atom_name: 'cardAtom'}

const CardAtom = styled((props: ApCardProps) => {
  return (
    <Card {...apAtomName} {...props}>
      {props.children}
    </Card>
  )
})`
  ${cardStyles}
`

export default CardAtom
